import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendProductSaveContainer from '../../../containers/recommend/product/RecommendProductSaveContainer';
import { recommendProductActions } from '../../../store/modules/recommend/product';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
  RECOMMEND_PRODUCT_SAVE_MODEL,
} from '../../../store/modules/recommend/product/models';
import { RECOMMEND_PRODUCT_PAGE_NAME } from '../../../constants/service/app/recommendProductConstants';

class RecommendProductCopy extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendProductSave'],
      value: RECOMMEND_PRODUCT_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendProductId) => {
    const { prepareCopyRecommendProduct } = this.props;

    prepareCopyRecommendProduct({
      recommendProductId,
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_PRODUCT_PAGE_NAME.RECOMMEND_PRODUCT_COPY}>
        <RecommendProductSaveContainer typeDisabled={true} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendProductActions.setData,
  prepareCopyRecommendProduct: recommendProductActions.prepareCopyRecommendProduct,
};

export default connect(null, mapDispatchToProps)(withRouter(RecommendProductCopy));
